<template>
  <div class="series-list-item" :style="seriesListItemStyles">
    <div class="container">
      <div class="content">
        <div class="main">
          <div class="left">
            <SeriesListItemHeader :item="item" />
            <SeriesListItemContent :item="item" />
          </div>
          <div class="right">
            <SeriesListItemThumbnail :item="item" />
          </div>
        </div>
        <SeriesListItemFooter :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import SeriesListItemHeader from '@/series/index/components/series-list-item-header';
import SeriesListItemContent from '@/series/index/components/series-list-item-content';
import SeriesListItemFooter from '@/series/index/components/series-list-item-footer';
import SeriesListItemThumbnail from '@/series/index/components/series-list-item-thumbnail';

export default defineComponent({
  name: 'SeriesListItem',

  /**
   * 属性
   */
  props: {
    item: Object,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    seriesListItemStyles() {
      const gradientStyles = this.item.gradient
        .map(gradient => {
          const { type: gradientType, direction, stops } = gradient;

          const gradientStops = stops
            .map(stop => {
              return `${stop.color} ${stop.colorStop}`;
            })
            .join(',');

          const gradientStyle = `
            ${gradientType}(
              ${direction}, 
              ${gradientStops}
            )
          `;

          return gradientStyle;
        })
        .join(',');

      return {
        background: gradientStyles,
        '--series-color': this.item.color,
      };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    SeriesListItemThumbnail,
    SeriesListItemFooter,
    SeriesListItemContent,
    SeriesListItemHeader,
  },
});
</script>

<style scoped>
@import './styles/series-list-item.css';
</style>
